import { Skeleton } from '@mui/material';
import clsx from 'clsx';

import { TransactionStatus } from '@features/transactions/constants';
import { getStatusColors } from '@features/transactions/helper';
import { valueOf } from '@utils/generic';

interface TransactionDetailsCardProps {
  paymentDetails: any;
  transactionStatus: TransactionStatus;
  isLoading?: boolean;
}

const TransactionDetailsCard = ({
  paymentDetails,
  transactionStatus,
  isLoading = false
}: TransactionDetailsCardProps) => {
  const keyStyle = ' text-grey text-sm font-normal';
  const { bgColor, textColor } = getStatusColors(
    valueOf(paymentDetails.value) as string
  );
  const valueStyle = clsx(
    'my-auto ml-auto max-w-70 break-words text-right  text-content',
    paymentDetails.className ? 'text-sm font-medium' : 'text-sm',
    paymentDetails.className,
    paymentDetails.title === 'Status'
      ? `rounded-lg px-2.5 py-1 ${bgColor} ${textColor}`
      : ''
  );

  return (
    <div
      key={paymentDetails.title}
      className="flex w-full items-center justify-stretch pb-2"
    >
      {isLoading ? (
        <div className="w-full">
          <Skeleton
            key={Math.random()}
            animation="wave"
            className="size-full"
          />
        </div>
      ) : (
        <>
          <span className={keyStyle}>
            {paymentDetails.title === 'Paid By' &&
            transactionStatus === TransactionStatus.PROCCESSING
              ? 'To be paid by'
              : paymentDetails.title}
          </span>
          <span className={valueStyle}>
            {paymentDetails.title.trim() === 'Notes'
              ? valueOf(`${paymentDetails.value}`.trim())
              : valueOf(paymentDetails.value)}
          </span>
        </>
      )}
    </div>
  );
};

export default TransactionDetailsCard;
